import { Link } from "react-router-dom";
import { fmtDate, fmtCurrency } from "../../lib/status";
import { Info } from "./customerUtils";

const STATUS_TONE = {
  collected: "bg-emerald-100 text-emerald-800", partially_collected: "bg-amber-100 text-amber-800",
  refunded: "bg-slate-100 text-slate-600", partial_refund: "bg-slate-100 text-slate-600",
  withheld: "bg-rose-100 text-rose-800", disputed: "bg-rose-100 text-rose-800",
  resolved: "bg-slate-100 text-slate-600", pending: "bg-slate-100 text-slate-600",
};

export function CustomerDepositsTab({ profile }) {
  const dep = profile.deposits || {};
  const bookings = profile.bookings || {};
  const allBookings = [
    ...(bookings.current || []), ...(bookings.upcoming || []),
    ...(bookings.completed || []), ...(bookings.cancelled || []), ...(bookings.no_show || []),
  ].filter((b) => (b.deposit_required || 0) > 0 || (b.deposit_collected_amount || 0) > 0);

  return (
    <div className="space-y-4" data-testid="cp-deposits">
      <div className="rounded-xl border border-slate-200 bg-white p-6">
        <h3 className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-slate-500">Totals across all bookings</h3>
        <dl className="mt-3 grid sm:grid-cols-5 gap-4 text-sm">
          <Info label="Required" value={fmtCurrency(dep.required_total)} />
          <Info label="Collected" value={fmtCurrency(dep.collected_total)} />
          <Info label="Refunded" value={fmtCurrency(dep.refunded_total)} />
          <Info label="Withheld" value={fmtCurrency(dep.withheld_total)} />
          <Info label="Outstanding" value={fmtCurrency(dep.outstanding_total)} />
        </dl>
      </div>

      {allBookings.length === 0 ? (
        <div className="rounded-xl border border-slate-200 bg-white p-6 text-sm text-slate-500" data-testid="cp-deposits-empty">
          No bookings with a deposit on file for this customer.
        </div>
      ) : (
        <div className="rounded-xl border border-slate-200 bg-white overflow-hidden">
          <ul className="divide-y divide-slate-100">
            {allBookings.map((b) => (
              <li key={b.id} className="p-4" data-testid={`cp-deposit-${b.id}`}>
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <Link to={`/app/bookings/${b.id}`} className="font-medium text-slate-900 hover:underline">
                    {b.booking_reference} <span className="text-slate-500 font-normal">· {b.vehicle?.name || "-"}</span>
                  </Link>
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium capitalize ${STATUS_TONE[b.deposit_status] || STATUS_TONE.pending}`}>
                    {(b.deposit_status || "pending").replace(/_/g, " ")}
                  </span>
                </div>
                <div className="text-xs text-slate-500 mt-1">
                  Required {fmtCurrency(b.deposit_required)} · Collected {fmtCurrency(b.deposit_collected_amount)}
                  {b.deposit_refunded_amount > 0 && <> · Refunded {fmtCurrency(b.deposit_refunded_amount)}</>}
                  {b.deposit_withheld_amount > 0 && <> · Withheld {fmtCurrency(b.deposit_withheld_amount)}</>}
                  {" · "}{fmtDate(b.start_datetime)}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
